import { render, staticRenderFns } from "./ParcoursCompleteNotificationDiv.vue?vue&type=template&id=27d698fe&scoped=true&"
import script from "./ParcoursCompleteNotificationDiv.vue?vue&type=script&lang=js&"
export * from "./ParcoursCompleteNotificationDiv.vue?vue&type=script&lang=js&"
import style0 from "./ParcoursCompleteNotificationDiv.vue?vue&type=style&index=0&id=27d698fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d698fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VIcon})
